import AutomaticRepliesOption from 'owa-automatic-replies-option/lib/AutomaticRepliesOption';
import { initLoadMailboxAutomaticRepliesConfiguration } from 'owa-automatic-replies-option';
var automaticRepliesSubCategory = {
    key: 'automaticReplies',
    titleStringKey: 'optionSubcategory_automaticReplies',
    options: [AutomaticRepliesOption],
    onSelected: function () {
        return initLoadMailboxAutomaticRepliesConfiguration();
    },
};
export default automaticRepliesSubCategory;
//# sourceMappingURL=automaticRepliesSubCategory.js.map